"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return DebugMgr;
    }
});
const _debug = /*#__PURE__*/ _interop_require_default(require("debug"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const namespaces = {};
const levels = {
    api: 'A',
    info: 'I',
    error: 'E',
    warn: 'W',
    debug: 'D'
};
let DebugMgr = class DebugMgr {
    static _create(namespace) {
        if (namespaces[namespace]) {
            namespaces[namespace][`${namespace}_A`].enabled = _debug.default.enabled(`${namespace}_A`);
            namespaces[namespace][`${namespace}_D`].enabled = _debug.default.enabled(`${namespace}_D`);
            namespaces[namespace][`${namespace}_I`].enabled = _debug.default.enabled(`${namespace}_I`);
            namespaces[namespace][`${namespace}_W`].enabled = _debug.default.enabled(`${namespace}_W`);
            namespaces[namespace][`${namespace}_E`].enabled = _debug.default.enabled(`${namespace}_E`);
        } else {
            namespaces[namespace] = {};
            namespaces[namespace][`${namespace}_A`] = {
                level: 'api',
                enabled: _debug.default.enabled(`${namespace}_A`)
            };
            namespaces[namespace][`${namespace}_W`] = {
                level: 'warn',
                enabled: _debug.default.enabled(`${namespace}_W`)
            };
            namespaces[namespace][`${namespace}_I`] = {
                level: 'info',
                enabled: _debug.default.enabled(`${namespace}_I`)
            };
            namespaces[namespace][`${namespace}_E`] = {
                level: 'error',
                enabled: _debug.default.enabled(`${namespace}_E`)
            };
            namespaces[namespace][`${namespace}_D`] = {
                level: 'debug',
                enabled: _debug.default.enabled(`${namespace}_D`)
            };
        }
    }
    static createNamespace(namespace) {
        if (!(namespace in namespaces)) {
            this._create(namespace);
        // console.log(namespaces);
        }
    }
    static getNamespaces() {
        return namespaces;
    }
    static refreshNamespace(namespace) {
        this._create(namespace);
    }
    static enable(namespace, level) {
        const toBeEnabled = `${namespace}_${levels[level]},${_debug.default.disable()}`;
        _debug.default.enable(`${toBeEnabled}`);
        this.refreshNamespace(namespace);
    }
    static disable(namespace, level) {
        const toBeRemoved = `${namespace}_${levels[level]}`;
        let list = `${_debug.default.disable()}`;
        list = list.replace(toBeRemoved, '');
        _debug.default.enable(list);
        this.refreshNamespace(namespace);
    }
    static enableAll(namespace) {
        for(const key in levels){
            _debug.default.enable(`${namespace}_${levels[key]}`);
            this.refreshNamespace(namespace);
        }
    }
    static disableAll() {
        _debug.default.disable();
    }
};
